import constructSizeForm from 'utils/constructSizeForm'
import getMediaURL from 'utils/getMediaURL'
import canHaveTargetMedia from 'utils/canHaveTargetMedia'

export default function setOrder({ state, props }) {
  const { order, target } = props
  state.set('basket.orderId', order.id)
  const unit = state.get('basket.unit')
  const itemsInState = Object.keys(
    state.get('basket.basketItems')
  ).filter(item => {
    return !target
  })

  const basketItems = order.orderItems
    .filter(item => {
      return itemsInState.indexOf(item.id) === -1
    })
    .reduce((acc, item) => {
      const { source, id: orderItemId, target } = item
      const { name, thumbnail, id, metaData, restriction } = source

      let done = false
      let ratio = null
      if (metaData) {
        ratio = metaData.ratio
      }

      if (!canHaveTargetMedia(name)) {
        done = true
      } else {
        if (target.name) {
          done = true
        }
        if (ratio && !ratio.width) {
          done = false
        }
      }

      acc[orderItemId] = {
        orderItemId,
        id,
        target,
        ratio,
        name,
        thumbnail: thumbnail ? getMediaURL(thumbnail) : null,
        form: constructSizeForm(unit, ratio, target),
        done,
        restriction
      }

      return acc
    }, {})
  state.merge('basket.basketItems', basketItems)
}



// WEBPACK FOOTER //
// ./src/modules/App/actions/setOrder.js